import { CanDeactivateFn } from '@angular/router';

/** Shape the guard needs — keeps the guard statically importable while the component stays lazy. */
export interface DirtyAware {
    dirty: boolean;
    submittedStatus: string | null;
}

/** Warns before navigating away from a compose flow with unsaved changes. */
export const composeExitGuard: CanDeactivateFn<DirtyAware> = component => {
    if (!component.dirty || component.submittedStatus) return true;
    return window.confirm('You have unsaved changes in this broadcast. Leave without saving?');
};
